import {API_BASE_URL, PAGE_SIZE} from '../../constants';
import {RefreshAssetsRequestDto} from '../../models';
import {post} from '../api';

export function search(
  data: string,
  token: string | undefined,
  signal: AbortSignal,
  page: number,
  sort: string,
) {
  return post(`${API_BASE_URL}/search?size=${PAGE_SIZE}&page=${page}${sort}`, {
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
    signal: signal,
  });
}

export function refreshBatch(
  assetIds: string[],
  structureId: string | undefined,
  token: string | undefined,
  signal: AbortSignal,
) {
  return post(`${API_BASE_URL}/search/refresh-batch`, {
    data: {assetIds, structureId} as RefreshAssetsRequestDto,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
    signal: signal,
  });
}
